export default __webpack_public_path__ + "static/media/IMG_5334.ed65be70.WEBP";